export const BRAND_THEME_VARIABLE_NAMES = [
  '--gray-light',
  '--primary',
  '--primary-op50',
  '--primary-op80',
  '--primary-dark',
  '--primary-darker',
  '--secondary',
  '--success',
  '--info',
  '--warning',
  '--danger',
  '--light',
  '--dark',
  '--bg-app',
  '--bg-surface',
  '--sidebar-hover',
  '--sidebar-active',
  '--separator-color',
  '--content-text-color',
  '--content-lighter-text-color',
  '--form-input-text-color',
  '--form-placeholder-color',
  '--form-input-bg',
  '--form-input-border-color',
  '--form-input-focus-bg',
  '--form-input-focus-border-color',
  '--form-input-addon-bg',
  '--nav-card-bg-menu-default',
  '--nav-card-bg-menu-home',
  '--nav-card-bg-hover',
  '--nav-card-label-normal',
  '--nav-card-label-hover',
  '--nav-card-label-disabled',
  '--nav-card-icon-normal',
  '--nav-card-icon-hover',
  '--nav-card-icon-disabled',
  '--font-family-sans-serif',
  '--font-family-monospace',
  '--body-font-family',
] as const;

export type BrandThemeVariableName = (typeof BRAND_THEME_VARIABLE_NAMES)[number];

export type BrandThemeVariables = Partial<Record<BrandThemeVariableName, string>>;

export function defineThemeVariables(
  themeVariables: BrandThemeVariables
): BrandThemeVariables {
  return themeVariables;
}
